<template>
  <div class="banner">
    <div class="top">便捷 | 智能</div>
    <div class="title">在线考试系统</div>
    <div class="info">
      <span>8</span> 大场景，<span>10</span> 大题型，<span>12</span>
      种防作弊措施<br />
      微信扫一扫，现在就能考！
    </div>
    <div>
      <a class="btn-blue-hover" style="margin-right: 20px" @click="goTest"
        >现在体验</a
      ><a class="btn-fff" @click="chatShow">咨询顾问</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goTest() {
      this.$bus.emit('goTest')
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  height: 450px;
  width: 100%;
  background: url('~@/static/images/exam-top-bg.png') no-repeat center top;

  text-align: center;
  font-weight: 300;
  font-size: 16px;
  padding-top: 80px;
  background-size: cover;
  .top {
    padding: 0px 0px 30px;
  }
  .title {
    font-size: 40px;
  }
  .info {
    padding: 30px 0px;
    line-height: 30px;
    span {
      color: #29bdb9;
      font-weight: bold;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/exam/banner.vue